const getTheme = () => (typeof sessionStorage !== "undefined" ? sessionStorage.getItem("theme") : null);

const setTableHeaderColor = () => {
    if (getTheme() === "default") return "#EDFFFE";
    if (getTheme() === "light") return "#E8E8E8 ";
    if (getTheme() === "dark") return "#17202A";
    return "#EDFFFE";
};
const setThemeColor = () => {
    if (getTheme() === "default") return "#04B7B1";
    if (getTheme() === "light") return "#B6B6B6";
    if (getTheme() === "dark") return "#000000";
    return "#04B7B1";
};
const setTableHeadTextColor = () => {
    if (getTheme() === "dark") return "#ffffff";
    return "#1a1917";
};
const setTableDataTextColor = () => {
    if (getTheme() === "dark") return "#ffffff";
    return getTheme() === "light" ? "#1a1917" : "#2F2A53";
};
const setConstrastColor = () => (getTheme() === "light" ? "#1a1917" : "#ffffff");
const setHoverColor = () => {
    if (getTheme() === "default") return "#E9FCF9 ";
    if (getTheme() === "light") return "#E5DEDE";
    if (getTheme() === "dark") return "#504F4F";
    return "#E9FCF9 ";
};
const setBgColor = () => (getTheme() === "dark" ? "#212F3D" : "#ffffff");
const setListItemsColor = () => (getTheme() === "dark" ? "#ffffff" : "#1a1917");
const setListIconColor = () => {
    if (getTheme() === "default") return "#04B7B1";
    if (getTheme() === "light") return "#E8E8E8 ";
    return "#ffffff";
};
const setIconBgIcon = () => "#ffffff";
const setTableBody = () => (getTheme() === "dark" ? "#121212" : "#ffffff");
const setTextColor = () => (getTheme() === "dark" ? "#ffffff" : "#000000");
const setHighlightColor = () => (getTheme() === "light" ? "#B6B6B6" : "#04B7B1");
const settabsColor = () => (getTheme() === "dark" ? "#ffffff" : "#000000");
const setTopDivbackgound = () => (getTheme() === "dark" ? "#17202A" : "#ffffff");
const setPagiantionTxtColor = () => (getTheme() === "dark" ? "#ffffff" : "#04B7B1");
const setSortingIconColor = () => (getTheme() === "dark" ? "#ffffff" : "#04B7B1");
const setTableCard = () => (getTheme() === "dark" ? "#17202A" : "#ffffff");
const setSecondaryColor = () => (getTheme() === "dark" ? "#ffffff" : "#04B7B1");
const setPopupBackground = () => (getTheme() === "dark" ? "#566573" : "#ffffff");
const setIconColor = () => (getTheme() === "dark" ? "#ffffff" : "#04B7B1");
const setHelperText = () => (getTheme() === "dark" ? "#ffffff" : "#000000");
const setCompBgColor = () => "#F5F8F7";
const setThemeLightClr = () => "#E4F2F0";

export const Colors = {
    TableHeaderBarBGColor: setTableHeaderColor(),
    ThemeColor: setThemeColor(),
    SecondaryColor: setSecondaryColor(),
    TableHeaderTextColor: setTableHeadTextColor(),
    TableProfilDetails: setTableDataTextColor(),
    HoverColor: setHoverColor(),
    BgColor: setBgColor(),
    ListItems: setListItemsColor(),
    ListIcons: setListIconColor(),
    IconCircleBgColor: setIconBgIcon(),
    TableBody: setTableBody(),
    ContrastText: setConstrastColor(),
    HelperText: setHelperText(),
    TextColor: setTextColor(),
    HighlightColor: setHighlightColor(),
    TabsColor: settabsColor(),
    pageTopBackground: setTopDivbackgound(),
    PagiantionTxtColor: setPagiantionTxtColor(),
    SortIconColor: setSortingIconColor(),
    TableCard: setTableCard(),
    PopupBackground: setPopupBackground(),
    IconColor: setIconColor(),
    ComponentBgColor: setCompBgColor(),
    ThemeLightColor: setThemeLightClr(),
    SideMenuAndMainHeadingText: "#2F2A53",
    Tabs: "#1A1A1A",
    DateFilter: "#696969",
    CardMAinHeading: "#04B7B1",
    SideMenuBranchHeading: "#2F2A53",
    DashBoardCardContents: "#696969",
    SelectedItemsBGColor: "#04B7B1",
    SelectedItemsBGText: "#FFFFFF",
    TableContentsTextColor: "#2E2E2E",
    HeaderBarBGColor: "#EDFFFE",
    HeaderBarTextColor: "#1A1A1A",
    defaulttheme: "#04B7B1",
    green: "#43C64F",
    black: "#1a1917",
    themeBlue: "#262941",
    themePink: "#F25364",
    white: "#ffffff",
    red: "#F1584A",
    themeDark: "#04b7b1",
    disableLabelColor: "#A9A9A9",
    themeBackgroud: "#04b7b1",
    Primary: "#04B7B1",
    SecondaryFill: "#E4F2F0",
    Background: "#F5F8F7",
    configHomeBg: "#F5F8F7",
    SecondaryText: "#616161",
    HeadText: "#202020",
};
